import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/AccountManagement';
import { displayName } from '../../../App';
import AccountManagementProvider from '../../context/accountManagement';

function AccountManagement() {
  document.title = `${displayName}: Account Management`;

  return (
    <MainInfoTracLayout className="min-h-[100vh] bg-white">
      <AccountManagementProvider>
        <Content />
      </AccountManagementProvider>
    </MainInfoTracLayout>
  );
}

export default AccountManagement;
